// extracted by mini-css-extract-plugin
export default {"container":"Tip_container__w4WpE","missing":"Tip_missing__Ufstb"};